import template from './deeplink-desktop.component.html';
import { createQr } from '../../../utils/qr';

angular
    .module('Toke')
    .component('appDeeplinkDesktop', {
        template,
        bindings: {
            data: '<',
            state: '<'
        },
        controller: DeeplinkDesktopController
    });

DeeplinkDesktopController.$inject = ['$element', '$timeout', '$scope'];

function DeeplinkDesktopController($element, $timeout, $scope) {

    const vm = this;

    vm.copyLink = copyLink;

    vm.copyStatus = 'idle';

    let resetTimeout = null;

    vm.$postLink = function () {
        $timeout(generateQr);
    };

    /**
     * Genera QR para la URL actual
     */
    function generateQr() {

        const qrContainer = angular
            .element($element)
            .find('.deeplink-desktop__qr')[0];

        if (qrContainer) {
            createQr(qrContainer, vm.state.currentUrl, vm.data.desktop.qrLogo);
        }
    }

    /**
     * Copia la URL actual al portapapeles
     */
    async function copyLink() {

        if (vm.copyStatus === 'success') {
            return;
        }

        try {

            vm.copyStatus = 'pressed';

            await navigator.clipboard.writeText(
                vm.state.currentUrl
            );

            vm.copyStatus = 'success';

            safeDigest();

            if (resetTimeout) {
                $timeout.cancel(resetTimeout);
            }

            resetTimeout = $timeout(() => {

                vm.copyStatus = 'idle';

            }, 2000);

        } catch (error) {

            vm.copyStatus = 'idle';

            safeDigest();
        }
    }

    function safeDigest() {
        if (!$scope.$$phase) {
            $scope.$applyAsync();
        }
    }
}